module.exports = __webpack_public_path__ + "img/iconfont.b5274337.svg";